// extracted by mini-css-extract-plugin
module.exports = {"heart":"AddToFavorite_heart__ZRdvm","is-active":"AddToFavorite_is-active__3cs96","star":"AddToFavorite_star__2LASu"};